/**
 * Transform a single dimension object to a URL compatible query string
 */
export const objectToQueryString = (
  values: {
    [key: string]: string | number | boolean | string[] | number[] | undefined;
  },
  debug?: true,
): string => {
  const queryString =
    !!values &&
    Object.entries(values)
      // if entry is not `null` or an empty string, let's use it
      .reduce((acc: any, x: any) => {
        // index not `total`
        if (x[0] !== 'total') {
          if (Array.isArray(x[1])) {
            // push into accumulator
            x[1].forEach((value) => {
              acc.push(
                `${encodeURIComponent(x[0])}=${encodeURIComponent(value)}`,
              );
            });
          } else {
            // value not null or undefined

            x[1] !== null &&
              x[1] !== undefined &&
              // value not empty
              x[1] !== '' &&
              // push into accumulator
              acc.push(
                `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`,
              );
          }
        }

        return acc;
      }, [])
      .join('&');

  if (debug) {
    console.log('Converting object to query string', values, queryString);
  }

  return queryString;
};
